import { EvaluationResults, getEvaluationResults as API } from '@belimo-retrofit-portal/logic';
import { createSelector } from 'reselect';
import { getHvacData } from 'src/modules/hvac/selectors/getHvacResults';

export const getEvaluationResults = createSelector([
  getHvacData,
], (data): EvaluationResults => API(data));
